import React from 'react';

import Header from '../../Components/Dashboard/Header/Header';
import Licenses from '../../Components/Dashboard/Admin/Licenses/List.js';


export default function LicensesPage() {
  return (
    <>
      <Header/>
      <div className="body">
        <Licenses/>
      </div>
    </>
  );
}
